import { ToggleInput } from './Style'

interface ToggleProps {
  id?: string
  isActive: boolean
  isDisabled?: boolean
  toggle: VoidFunction
}

function Toggle({ id, isActive = false, isDisabled = false, toggle }: ToggleProps) {
  return <ToggleInput type='checkbox' id={id} checked={isActive} disabled={isDisabled} onChange={toggle} />
}

export { Toggle }
